<template>
    <div class="activeDetail_set">
        <div class="active_butTitle">
            <h4>填写报名信息</h4>
        </div>
        <div class="activeDetail_setbox">
            <!-- <p class="activeDetail_setTitle">
              <i></i> 信息填写
            </p> -->
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <div class="activeDetail_mesBox flex">
                    <div class="activeDetail_mes">
                        <el-form-item label="姓名:" prop="username">
                            <el-input v-model="ruleForm.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </div>
                    <div class="activeDetail_mes">
                        <el-form-item label="联系电话:" prop="userNumber">
                            <el-input v-model="ruleForm.userNumber" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="activeDetail_mesBox flex">
                    <div class="activeDetail_mes">
                        <!-- <p>参赛主体:</p> -->
                        <el-form-item label="参赛主体:" prop="radio1">
                            <el-radio-group v-model="ruleForm.radio1">
                                <el-radio-button label="PERSONAL" value="PERSONAL">个人</el-radio-button>
                                <el-radio-button label="TEAM" value="TEAM">团体</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="activeDetail_mes">
                        <!-- <p>报名单位/院校:</p> -->
                        <el-form-item label="单位/院校:" prop="teamName">
                            <el-input v-model="ruleForm.teamName" placeholder="请输入单位/院校名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="activeDetail_mesBox flex">
                    <div class="activeDetail_mes">
                        <!-- <p>报名赛道:</p> -->
                        <el-form-item label="报名赛道:" prop="activityWayUuid">
                            <el-select v-model="ruleForm.activityWayUuid" multiple placeholder="请选择报名的赛道"
                                       style="width: 300px;">
                                <el-option v-for="(item, index) in activityWayList"
                                           :label="item.name" :key="index"
                                           :value="item.uuid"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="activeDetail_mes">
                        <!-- <p>指导老师:</p> -->
                        <el-form-item label="指导老师:" prop="teamMember">
                            <el-input type="textarea" v-model="ruleForm.teamMember"
                                      placeholder="请输入指导老师名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="activeDetail_mesBox">
                    <el-form-item prop="checked">
                        <el-checkbox v-model="ruleForm.checked"><span>我已阅读并同意<span style="color:rgb(245, 108, 108);border-bottom:1px solid rgb(245, 108, 108)" @click="openContent">《{{Xieyititle}}》</span></span>
                        </el-checkbox>
                    </el-form-item>
                </div>
                <div class="activeDetail_mesBox">
                    <el-form-item>
                        <div class="content" style="color:#F56C6C;padding-left: 25px;">报名信息提交以后不可修改！</div>
                    </el-form-item>
                </div>
            </el-form>
            <div class="active_but">
                <button @click="submit">确认报名</button>
                <!-- <el-button type="primary" plain @click="submit">确认报名</el-button> -->
            </div>
        </div>
        <!-- 报名成功 -->
        <el-dialog :visible.sync="submitSuccess" @close="closeSuccess" class="dialogSubmit">
            <el-result icon="success" title="报名成功">
                <template slot="extra">
                    <el-button size="medium" type="text" class="successBtn" @click="jumpUploadworks">点击前往上传作品
                    </el-button>
                </template>
            </el-result>
        </el-dialog>
        <!-- 协议 -->
        <el-dialog
                :title="Xieyititle"
                center
                :visible.sync="dialogVisible"
                class="xieyiDialog"
                width="900px">
            <el-scrollbar style="height: 600px">
                <div class="vHtmlMess" v-html="content"></div>
            </el-scrollbar>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agree()">同意服务条款</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getNewcurrent, saveActivitySign, getInfoByWordNo, getActivityWayList,
        getIdentity, getEnterpriseCredentials
    } from '../../../utils/interface';

    export default {
        data() {
            return {
                // nickname: '',
                // username: '',
                // userNumber: '',
                // teamName: '',
                // radio1: 'PERSONAL',
                // checked: true,
                // teamMember:"",
                Xieyititle: "",
                activityUuid: "",
                submitSuccess: false,
                content: '',
                dialogVisible: false,
                activityWayList: [],
                ruleForm: {
                    account:'',
                    userNumber: '',
                    username: '',
                    radio1: 'PERSONAL',
                    teamName: '',
                    teamMember: '',
                    checked: false,
                    nickName: '',
                    wayList: [],
                    activityWayUuid: '',
                },
                rules: {
                    userNumber: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                    ],
                    username: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                    ],
                    radio1: [
                        {required: true, message: '请选择参赛主体', trigger: 'blur'},
                    ],
                    teamName: [
                        {required: true, message: '请输入单位/院校名称，若无则填“无”', trigger: 'blur'},
                    ],
                    /*teamMember: [
                        {required: true, message: '请输入指导老师名称', trigger: 'blur'},
                    ],*/
                    checked: [
                        {required: true, message: '请勾选同意条款', trigger: 'change'},
                    ],
                    activityWayUuid: [
                        {required: true, message: '请选择活动赛道', trigger: 'change'},
                    ],
                },
            }
        },
        methods: {
            openContent(){
                this.ruleForm.checked = !this.ruleForm.checked;
                this.dialogVisible = true;
            },
            init(uuid) {
                this.reset();
                this.activityUuid = uuid;
                // 获取用户信息
                getNewcurrent().then((res) => {
                    // 实名认证个人用户直接获取信息
                    if (res.identity === "ANONYMOUS") {
                        this.ruleForm.nickName = res.name;
                        this.ruleForm.username = res.realName;
                        this.ruleForm.account = res.tel;
                    }else if (res.identity === "PERSONAL") {
                        this.ruleForm.nickName = res.name;
                        this.ruleForm.username = res.realName;
                        //this.ruleForm.userNumber = res.tel;
                        this.ruleForm.account = res.tel;
                    } else if (res.identity === "ENTERPRISE") {
                        // 实名认证企业用户单独获取企业信息
                        getEnterpriseCredentials({userUuid: res.uuid}).then((result) => {
                            this.ruleForm.nickName = res.name;
                            this.ruleForm.username = result.data.contact;
                            this.ruleForm.userNumber = result.data.contactTel;
                            this.ruleForm.account = res.tel;
                        });
                    }
                });
                getInfoByWordNo({"wordNo": "WYBM"}).then((res) => {
                    if (res && res.data) {
                        this.content = res.data.content;
                        this.Xieyititle = res.data.title
                    }
                });
                getActivityWayList({activityUuid: uuid}).then((res) => {
                    this.activityWayList = res;
                });
            },
            reset() {
                this.$nextTick(() => {
                    // DOM 更新了
                    this.$refs["ruleForm"].clearValidate()
                });
            },
            agree() {
                this.ruleForm.checked = true;
                this.dialogVisible = false
            },
            submit() {
                let params = {
                    activityUuid: this.activityUuid,
                    nickName: this.ruleForm.nickName,
                    tel: this.ruleForm.userNumber,
                    account:this.ruleForm.account,
                    name: this.ruleForm.username,
                    teamName: this.ruleForm.teamName,
                    signType: this.ruleForm.radio1,
                    teamMember: this.ruleForm.teamMember,
                    wayList: this.ruleForm.activityWayUuid
                }
                console.log(params);
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        saveActivitySign(params).then((res) => {
                            if (res.success) {
                                this.submitSuccess = true;
                                // this.$message.success("报名成功");
                                // 上传按钮展示
                                // this.$parent.refreshPage();
                            } else {
                                this.$message.error(res.message + ',请联系管理员');
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            jumpUploadworks() {
                /*window.sessionStorage.setItem('activeDetailsNums','02');
                this.$router.go(0)
                this.submitSuccess = false*/
                this.submitSuccess = false;
                this.$parent.refreshPage();
                window.open(this.$url.buyerWeb + "/#/activeJoin", '_target');
            },
            closeSuccess() {
                // this.$parent.refreshPage();
                // this.$parent.getIsSign();
            }
        },
    }
</script>
<style scoped lang="less">
    .activeDetail_set {
        width: 1200px;
        margin: 30px auto 0;
        background: #fff;
        padding: 57px 30px 34px;
        box-sizing: border-box;

        .active_butTitle {
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            color: #099;
            margin-bottom: 27px;
        }

        .activeDetail_setbox {
            .activeDetail_setTitle {
                font-size: 24px;

                i {
                    display: inline-block;
                    width: 15px;
                    height: 15px;
                    background: #099;
                    border-radius: 50%;
                    margin-right: 9px;
                }
            }

            .activeDetail_mesBox {
                align-items: center;
                margin-top: 30px;

                .activeDetail_mes {
                    display: flex;
                    align-items: center;
                    width: 50%;

                    /deep/ .el-textarea {
                        width: 224px;
                    }

                    /deep/ .el-radio-button__inner {
                        margin-right: 10px;
                        width: 108px;
                        height: 45px;
                        background: #F4F4F4;
                        border: 1px solid #DDDDDD;
                        opacity: 1;
                        border-radius: 4px;
                        line-height: 21px;
                    }

                    /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                        color: #FFF;
                        width: 108px;

                        background-color: #409EFF;
                        border-color: #409EFF;
                        -webkit-box-shadow: -1px 0 0 0 #409eff;
                        box-shadow: -1px 0 0 0 #409eff;
                    }

                    /deep/ .activeDetail .activeDetail_set .activeDetail_setbox .activeDetail_mesBox .activeDetail_mes[data-v-62bacabe] .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                        width: 108px;
                        border-radius: 4px;
                    }

                    p {
                        margin-right: 40px;
                        flex-shrink: 0;
                        width: 120px;
                    }

                    /deep/ .el-input {
                        width: 224px;
                        //height: 45px;
                    }
                }
            }
        }
    }

    .active_but {
        margin-top: 84px;
        text-align: center;

        button {
            background: #fff;
            width: 156px;
            height: 40px;
            border: 1px solid #099;
            color: #099;
            border-radius: 4px;
            cursor: pointer;
        }
    }

    .successBtn {
        border-bottom: 1px solid #409eff;
        border-radius: 0;
    }

    .xieyiDialog {
        /deep/ .el-scrollbar__wrap {
            overflow: auto;
        }
        /deep/.el-scrollbar {
            padding: 0 20px;
        }
    }

    .dialogSubmit {
        margin-top: 12vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/signUp.vue